/**
 * @see https://umijs.org/docs/max/access#access
 * */
export default function access(initialState: { currentUser?: API.CurrentUser } | undefined) {
  const { currentUser } = initialState ?? {};
  
  // 检查用户是否已登录
  const isLoggedIn = !!(currentUser && currentUser.data);
  
  return {
    // 基础登录权限
    isLoggedIn,
    // 管理员权限
    canAdmin: currentUser && currentUser.data && currentUser.data.access === 'admin',
    // 普通用户权限（已登录即可）
    canUser: isLoggedIn,
  };
}
